module.exports = __webpack_public_path__ + "static/media/1019849.010c1d1d.jpg";